import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import { isAuthenticated } from "./services/auth";

import Index from "./pages/index"
import Posgraduacao from "./pages/posgraduacao"
import Showcurso from "./pages/showcurso"
import ContactUs from "./pages/contateus"
import Posgraduacaobycategoria from "./pages/posgraduacaobycategoria"

import Inscricaograduacao from "./pages/User/inscrevaposgraduacao"

import IndexAdmin from "./pages/Admin/index"
import CategoriaAdmin from "./pages/Admin/categoria"
import EditCategoriaAdmin from "./pages/Admin/editcategoria"
import RemoverCategoriaAdmin from "./pages/Admin/removecategoria"
import CursosAdmin from "./pages/Admin/cursos"
import AddcursosAdmin from "./pages/Admin/addcursos"
import EditcursosAdmin from "./pages/Admin/editcursos"
import RemoverCursosAdmin from "./pages/Admin/removecurso"
import AlunosAdmin from "./pages/Admin/alunos"
import ChangePassUseradm from "./pages/Admin/changepassuser"
import RemoveAlunoAdm from "./pages/Admin/removealuno"
import EditAlunoAdmin from "./pages/Admin/editalunos"
import MudarSenhaAlunoAdmin from "./pages/Admin/mudarsenhaalunos"
import VerAlunoAdmin from "./pages/Admin/veralunos"
import MatriculaspagasAdmin from "./pages/Admin/matriculaspagas"
import MatriculasnaopagasAdmin from "./pages/Admin/matriculasunpaid"
import EditMatriculaAdm from "./pages/Admin/editmatricula"
import EditMatrizCurricular from "./pages/Admin/editmatrizcurricular"
import RemoveMatriculaAdm from "./pages/Admin/removematricula"


import ConfiguracaoAdmin from "./pages/Admin/configuracao"
import LoginAdmin from "./pages/Admin/login"


import LoginUser from "./pages/User/login"
import InscreverUser from "./pages/User/inscreva"
import InscreverloginUser from "./pages/User/inscrevalogin"
import IndexUser from "./pages/User/index"
import MeuscursosUser from "./pages/User/meuscursos"
import MeusDadosUser from "./pages/User/meusdados"

import MatrizCurricular from "./pages/Admin/matrizcurricular"

import DownloadUserData from "./pages/Admin/downloaduserdata"


import Unidades from "./pages/Admin/unidades"
import Administradores from "./pages/Admin/admunidades"




import MinhasFaturas from "./pages/User/faturas"
import FaturaAdm from "./pages/Admin/faturas"


import Faturacobranca from "./pages/Admin/faturasnaopaga"


import RelatorioMat from "./pages/Admin/relatoriointegral"
import RelatorioMatMensal from "./pages/Admin/relatoriomensal"
import RelatorioMatSemestral from "./pages/Admin/relatoriosemestral"
import RelatorioMatAnual from "./pages/Admin/relatorioanual"

import MatriculaAdd from "./pages/Admin/addmatricula"
import LogsAdm from "./pages/Admin/logs"
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={Index} /> 
      <Route exact path="/pos-graduacao" component={Posgraduacao} /> 
      <Route exact path="/pos-graduacao/:idcategoria" component={Posgraduacaobycategoria} /> 
      <Route path="/pos-graduacao/:nomecurso/:cursoid" component={Showcurso} />
      <Route path="/Curso-Curta-Duracao/:nomecurso/:cursoid" component={Showcurso} />

      <Route path="/contato" component={ContactUs} />

      <Route exact path="/admin/login/master" component={LoginAdmin} /> 
      <Route exact path="/admin/login" component={LoginAdmin} /> 

      <Route exact path="/user/login" component={LoginUser} /> 
      <Route exact path="/user/inscreva/:indicacao?" component={InscreverUser} />
      <Route exact path="/user/inscricaograduacao/:indicacao?" component={Inscricaograduacao} />
      <Route exact path="/user/faturas" component={MinhasFaturas} />
    

      
      <Route exact path="/user/inscreva/login/:dadouser/:indicacao?" component={InscreverloginUser} /> 



      
      <PrivateRoute exact path="/admin/datauserdata" component={DownloadUserData} /> 
      <PrivateRoute exact path="/admin" component={IndexAdmin} /> 
      <PrivateRoute exact path="/admin/categoria" component={CategoriaAdmin} />
      <PrivateRoute exact path="/admin/categoria/edit/:idcategoria" component={EditCategoriaAdmin} /> 
      <PrivateRoute exact path="/admin/categoria/remove/:idcategoria" component={RemoverCategoriaAdmin} /> 

      <PrivateRoute exact path="/admin/cursos" component={CursosAdmin} /> 
      <PrivateRoute exact path="/admin/cursos/add" component={AddcursosAdmin} /> 
      <PrivateRoute exact path="/admin/cursos/edit/:idcurso" component={EditcursosAdmin} />
      <PrivateRoute exact path="/admin/cursos/remove/:idcurso" component={RemoverCursosAdmin} />  
      <PrivateRoute exact path="/admin/cursos/matrizcurricular/:idcurso" component={MatrizCurricular} />
      <PrivateRoute exact path="/admin/cursos/matrizcurricular/:idcurso/:idmatriz" component={EditMatrizCurricular} />

      
      
      <PrivateRoute exact path="/admin/alunos" component={AlunosAdmin} /> 
      <PrivateRoute exact path="/admin/alunos/edit/:iduser" component={EditAlunoAdmin} /> 
      <PrivateRoute exact path="/admin/alunos/pass/:iduser" component={ChangePassUseradm} /> 
      <PrivateRoute exact path="/admin/alunos/remove/:iduser" component={RemoveAlunoAdm} /> 
      <PrivateRoute exact path="/admin/alunos/mudarsenha/:iduser" component={MudarSenhaAlunoAdmin} /> 
      <PrivateRoute exact path="/admin/alunos/ver/:iduser" component={VerAlunoAdmin} /> 


      <PrivateRoute exact path="/admin/matriculas" component={AlunosAdmin} /> 
      <PrivateRoute exact path="/admin/matricula/add" component={MatriculaAdd} /> 
      <PrivateRoute exact path="/admin/matriculas/paid" component={MatriculaspagasAdmin} /> 
      <PrivateRoute exact path="/admin/matriculas/unpaid" component={MatriculasnaopagasAdmin} /> 
      <PrivateRoute exact path="/admin/matricula/edit/:idmatricula" component={EditMatriculaAdm} /> 
      <PrivateRoute exact path="/admin/matricula/remove/:idmatricula" component={RemoveMatriculaAdm} /> 

      <PrivateRoute exact path="/admin/configuracao" component={ConfiguracaoAdmin} /> 
      <PrivateRoute exact path="/admin/faturas/:idmatricula?" component={FaturaAdm} /> 
      <PrivateRoute exact path="/admin/faturas/comercial/cobranca" component={Faturacobranca} /> 

      <PrivateRoute exact path="/admin/logs" component={LogsAdm} /> 

      <PrivateRoute exact path="/admin/relatorios" component={RelatorioMat} /> 
      <PrivateRoute exact path="/admin/relatorio/mensal/:month/:year" component={RelatorioMatMensal} /> 
      <PrivateRoute exact path="/admin/relatorio/semestral/:year" component={RelatorioMatSemestral} /> 
      <PrivateRoute exact path="/admin/relatorio/anual/:year" component={RelatorioMatAnual} /> 

      



      <PrivateRoute exact path="/user" component={MeuscursosUser} /> 
      <PrivateRoute exact path="/user/cursos" component={MeuscursosUser} /> 
      <PrivateRoute exact path="/user/meus_dados" component={MeusDadosUser} /> 
      


      <PrivateRoute exact path="/admin/unidades" component={Unidades} />
      <PrivateRoute exact path="/admin/administradores" component={Administradores} /> 
 


      <Route path="*" component={() => <h1>Page not found</h1>} />
    </Switch>
  </BrowserRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js